import {FC} from "react";
import Close from "../Svg/Close";
import { motion, AnimatePresence } from "framer-motion";
import useAppStore from "../../store";
import {useTranslation} from "react-i18next";
import Backdrop from "../Backdrop";
import Button from "../Base/Button";


const Alert:FC = () => {
    const {t} = useTranslation();
    const {alert, closeAlert} = useAppStore();

    const Description = () => {
        return <>
            {alert.description.map((item, index) => {
                return <p className="text__secondary" key={index}>{item}</p>
            })}
        </>
    }

    return <AnimatePresence>
        {alert.isOpen && (
            <>
                <div className="fixed inset-0 z-60 w-screen overflow-y-auto flex items-center justify-center p-4 sm:p-0" role="dialog" aria-modal="true">
                    <Backdrop onClick={closeAlert} />
                    <motion.div
                        className="relative overflow-hidden rounded-2xl alert text-left shadow-sm w-full max-w-[340px]"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.3 }}
                    >
                        <button onClick={closeAlert} className="absolute top-3 right-3 cursor-pointer">
                            <Close className="w-4 h-4" color="stroke-disabled-400" />
                        </button>
                        <div className="px-4 py-8 flex flex-col text-center">
                            {alert.title && <h2 className="title font-bold mb-4">{alert.title}</h2>}
                            {alert.description && <Description />}
                            <Button onClick={closeAlert} arrow={false} className="mt-6" text={alert.button ?? t('common.submit')} />
                        </div>
                    </motion.div>
                </div>
            </>
        )}
    </AnimatePresence>
}

export default Alert;